<template>
  <div class="row d-flex justify-content-center p-4">
    <div class="col-sm-4 searchbar p-1">
      <input
        class="form-control"
        type="search"
        aria-label="Search through site content"
        :placeholder="placeholder"
        v-model="search"
      />
    </div>
    <div class="col-sm-1 btn btn-primary text-center p-1 m-1" @click="getDevice">
      Search
    </div>
    <div class="col-sm-1 btn btn-primary text-center p-1 m-1" @click="clearSearch">
      Clear
    </div>
  </div>
</template>

<script>
import { apiCall } from "@/utils/api";
export default {
  data() {
    return {
      search: "",
      placeholder : "Search devices by name or id" ,
      device: [],
    };
  },
  methods: {
   getDevice(){
     this.$emit('searchInput', this.search.trim());
   } ,
   clearSearch(){
     this.search = "";
     this.placeholder = "Search devices by name or id";
     this.$emit('clear');
   }
  },
};
</script>

<style>
</style>